import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
export var ConnectionOpenResponse = /*#__PURE__*/function () {
  function ConnectionOpenResponse(statusCode, reason) {
    _classCallCheck(this, ConnectionOpenResponse);

    this.privStatusCode = statusCode;
    this.privReason = reason;
  }

  _createClass(ConnectionOpenResponse, [{
    key: "statusCode",
    get: function get() {
      return this.privStatusCode;
    }
  }, {
    key: "reason",
    get: function get() {
      return this.privReason;
    }
  }]);

  return ConnectionOpenResponse;
}();